import Box from '@mui/material/Box'
import styled from 'styled-components'

const LayoutBaseRoot = styled(Box)`
  overflow-x: hidden;
`

export { LayoutBaseRoot }
